import { FC } from 'react'
import { styled } from '@mui/material'
import { emptyFn } from '@portal/pkg-utils'

const StyledLogo = styled('div')({
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
})

export interface LogoProps {
  logoUrl: string
  className?: string
  onClick?: VoidFunction
}

export const Logo: FC<LogoProps> = ({ className, logoUrl, onClick = emptyFn }) => (
  <StyledLogo
    className={className}
    style={{ backgroundSize: 'contain', backgroundImage: `url(${logoUrl})` }}
    onClick={onClick}
  />
)
